export const detectedByLabels = {
  prometheus_sync: 'Prometheus Sync',
  service_monitor: 'Service Monitor',
  incident_detector: 'Incident Detector',
  event_router: 'Event Router',
  api: 'API',
  snmp_trap_receiver: 'SNMP Trap Receiver',
  snmp_vulnerability_checker: 'SNMP Vulnerability Checker',
  agent_check: 'Agent Check',
  anomaly_detector: 'Anomaly Detector',
  prometheus_alert: 'Prometheus Alert',
};
